module.exports = __webpack_public_path__ + "img/3.a379d027.jpg";